import React, {useEffect, useState} from "react";
import {Link, Navigate} from "react-router-dom";

import './Vital.create.scss';
import Button from "../../forms/buttons/Button";
import {useQuery} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import Select from "../../forms/inputs/Select";
import FormValidation from "../../forms/validation/formValidation";
import ButtonSwitch from "../../forms/buttons/Button.switch";
import VitalAlert from "./Vital.alert";

const alertFields = {
    'check_acknowledge_notification': { type: 'boll', required: true, value: true },
    'acknowledge_notification': { type: 'text', required: true, value: '' },
    'check_daily_summary': { type: 'bool', value: true },
    'daily_summary_email': { type: 'text', required: true, value: '' },
    'check_high': { type: 'bool', value: true },
    'high_condition': { type: 'text', value: '≥' },
    'high_value': { type: 'text', value: '' },
    'high_time': { type: 'text', value: '' },
    'high_time_condition': { type: 'text', value: 'mins' },
    'check_low': { type: 'bool', value: true },
    'low_condition': { type: 'text', value: '≤' },
    'low_value': { type: 'text',  value: '' },
    'low_time': { type: 'text', value: '' },
    'low_time_condition': { type: 'text', value: 'mins' },
    'check_escalations': { type: 'bool', value: true },
    'escalations': { type: 'array-items', value: [] },
};

function VitalCreate({ match, currentUser }) {
    const [vital, setVital] = useState(null);
    const [source, setSource] = useState(null);
    const [program, setProgram] = useState(null);
    const [sustainedData, setSustainedData] = useState({});
    const [instantaneousData, setInstantaneousData] = useState({});
    const [clinicianOptions, setClinicianOptions] = useState([]);

    const [sustainedAlert, setSustainedAlert] = useState(false);
    const [instantaneousAlert, setInstantaneousAlert] = useState(false);

    const [sustainedFields, setSustainedFields] = useState(alertFields);
    const [sustainedFormValid, setSustainedFormValid] = useState(false);
    const [instantaneousFields, setInstantaneousFields] = useState(alertFields);
    const [instantaneousFormValid, setInstantaneousFormValid] = useState(false);

    const [__submitting, __setSubmitting] = useState(false);

    useQuery(gqlSchemaLibrary.programs.query.getProgramById, {
        variables: {
            id: match.params.programId
        },
        onCompleted: ({ getProgramById }) => {
            console.log('program: ', getProgramById);
            setProgram(getProgramById);
        },
        fetchPolicy: 'cache-and-network'
    })

    useQuery(gqlSchemaLibrary.clinicians.queries.getCliniciansByOrg, {
        onCompleted: ({getCliniciansByOrg}) => {
            console.log('[User List] User Clinicians: ', getCliniciansByOrg);
            if (getCliniciansByOrg) {
                let items = [];
                getCliniciansByOrg.forEach((user) => {
                    if(user.role === 'Admin') {
                        items.push({
                            label: user.user.bio.firstname + " " + user.user.bio.lastname,
                            value: user._id
                        });
                    }
                });
                setClinicianOptions(items);
            }
        },
        fetchPolicy: 'cache-and-network'
    })

    const initForm = (form) => {
        if (!!match.params && match.params.vitalID && !!program) {

        } else {
            form.setValue('high_condition', '≥');
            form.setValue('high_time_condition', 'mins');
            form.setValue('low_condition', '≤');
            form.setValue('low_time_condition', 'mins');
        }
        form.setValue('check_escalations', true);
        form.setValue('check_acknowledge_notification', true);
        form.setValue('check_daily_summary', true);
        form.setValue('check_high', true);
        form.setValue('check_low', true);
    }

    useEffect(() => {
        const onFormChange = (key, value, field, valid) => {
            setSustainedData(prevState => ({
                ...prevState,
                [key]: value
            }));
            setSustainedFields(prevState => ({
                ...prevState,
                [key]: field
            }));
            setSustainedFormValid(valid);
        }
        let form = FormValidation(alertFields, onFormChange);
        initForm(form);
        setSustainedFields(form.data);
    }, [alertFields])

    useEffect(() => {
        const onFormChange = (key, value, field, valid) => {
            setInstantaneousData(prevState => ({
                ...prevState,
                [key]: value
            }));
            setInstantaneousFields(prevState => ({
                ...prevState,
                [key]: field
            }));
            setInstantaneousFormValid(valid);
        }
        let form = FormValidation(alertFields, onFormChange);
        initForm(form);
        setInstantaneousFields(form.data);
    }, [alertFields])

    const validateAndSubmit = () => {
        // EscalateRoutine
        const escalateRoutine = {};
        const alertNotification = {};
        console.log(sustainedData);
        console.log(instantaneousData);
    }

    const cancelVital = () => {
        Navigate(`/programs/detail/`+program._id);
    }

    const onChangeSustained = (bool) => {
        setSustainedAlert(bool);
    }

    const onChangeInstantaneous = (bool) => {
        setInstantaneousAlert(bool);
    }

    const onChangeSource = (s) => {
        setSource(s);
    }

    const onSelectedVital = (v) => {
        setVital(v);
    }

    const unSelectedVital = () => {
        setSource(null);
        setVital(null);
    }

    const vitalAcronym = (value) => {
        if (value === 'SPO2') { return 'O2' }
        if (value === 'Temp') { return 'T' }
        if (value === 'Position') { return 'P' }
        return value;
    }

    const vitalOptions = [
        {
            label: 'Heart Rate',
            value: 'HR',
            sustained: true,
            instantaneous: true
        },
        {
            label: 'Respiration Rate',
            value: 'RR',
            sustained: true,
            instantaneous: true
        },
        {
            label: 'Sp02',
            value: 'SPO2',
            sustained: true,
            instantaneous: false
        },
        {
            label: 'Temperature',
            value: 'Temp',
            sustained: true,
            instantaneous: false
        }
    ]

    const getVital = () => {
        if (!vital) {
            return {
                label: '',
                value: '',
                high: false,
                low: false
            };
        }
        const _vital = vitalOptions.find((v) => v.value === vital);
        if (_vital) {
            return _vital;
        }
        return {
            label: '',
            value: '',
            high: false,
            low: false
        };
    }

    const getSources = () => {
        if (!vital) {
            return [];
        }
        const sources = [
            {
                label: 'Life signal H1 patch',
                value: 'h1-patch',
                vitals: ['HR', 'RR', 'Temp']
            },
            {
                label: 'Biointellisense BioSticker',
                value: 'bioSticker',
                vitals: ['HR', 'RR', 'Temp']
            },
            {
                label: 'NONIN Oximeter 3230 BT',
                value: 'NONIN',
                vitals: ['SPO2']
            }
        ];
        return sources.filter((s) => s.vitals.includes(vital));
    }

    const getSourceDescription = () => {
        let data = {
            text: '',
            frequency: '',
            units: '',
            assumptions: '',
            alertsAndThresholds: '',
        };
        if (!source) {
            return data;
        }
        if (source === 'h1-patch') {
            data = {
                text: 'The H1 patch will provide continuous monitoring of ' + getVital().label ,
                frequency: 'Continuous, approximately every second',
                units: 'Beats per minute',
                assumptions: 'Predicted maximal heart rate = 220 - person\'s age',
                alertsAndThresholds: 'The Cherish maximal Harmony platform will continuously monitor all incoming rate values from\n' +
                    'the H1 patch and will trigger alerts for values that are out of bounds over specified durations',
            };
        } else if (source === 'bioSticker') {
            data = {
                text: '',
                frequency: '',
                units: '',
                assumptions: '',
                alertsAndThresholds: '',
            };
        } else if (source === 'NONIN') {
            data = {
                text: 'The Nonin pulse oximeter allows participants to manually collect data and can be sent to Cherish servers via SMS.',
                frequency: 'After participants SMS the SpO2 value to Cherish they will receive the following SMS acknowledge',
                units: '% of oxygen in the blood.',
                assumptions: 'Since SpO2 measurement is manual, patient will send SpO2 value via SMS to Cherish Health. ' +
                    'At any time or when the participant is instructed to by the CHA clinician.',
                alertsAndThresholds: 'Alerts will get triggered only when the patient sends SpO2 values to Cherish Health via SMS',
            };
        }
        return data;
    }

    if (!program) {
        return ''
    }

    return (
        <div className="programCreateVital">
            <div className="filter">
                <div className="filterOptions">
                    <i className="material-icons">
                        <Link to={`/programs/detail/${program._id}`}>
                            arrow_back_ios
                        </Link>
                    </i>
                    <div className="title">
                        <h3>{program.name}</h3>
                    </div>
                </div>
            </div>
            <div className="formContent" >
                <div className="title">
                    <h3>
                        Vitals configuration
                    </h3>
                    <Button className="button link" handleClick={cancelVital}>Cancel</Button>
                    <Button className="primary smallPad" handleClick={validateAndSubmit}>
                        <div className={`progressButton ${__submitting ? 'submitting' : ''}`}>
                            {__submitting ? <div className="_progressing"></div> : ''}
                            <span>Done</span>
                        </div>
                    </Button>
                </div>
                <div className="table scrollBar">
                    <div className="row _vitalInfo __selectMedium">
                        <div className="vitalIcon">
                            <span className={`_vital _${getVital().value}`}>{vitalAcronym(getVital().value)}</span>
                        </div>
                        <span className="name">{getVital().label}</span>
                        {
                            !vital?
                                <Select required={false} placeholder="--" onChange={onSelectedVital} options={vitalOptions}/> : <span className="link" onClick={unSelectedVital}>Change</span>
                        }
                    </div>
                    <div className="divider">
                    </div>
                    <div className="row __selectMedium">
                        <span className="label _gray">Data source</span>
                        <Select required={false} value={source} onChange={onChangeSource} placeholder="--" options={getSources()}/>
                    </div>
                    <div className="divider">
                    </div>
                    <div className="row">
                        <span className="label">
                        </span>
                        <p>{getSourceDescription().text}</p>
                    </div>
                    <div className="row">
                        <span className="label _gray">Frequency</span>
                        <p>{getSourceDescription().frequency}</p>
                    </div>
                    <div className="row">
                        <span className="label _gray">Units</span>
                        <p>{getSourceDescription().units}</p>
                    </div>
                    <div className="row">
                        <span className="label _gray">Assumptions</span>
                        <p>{getSourceDescription().assumptions}</p>
                    </div>
                    <div className="row">
                        <span className="label _gray">Alerts and thresholds</span>
                        <p>{getSourceDescription().alertsAndThresholds}</p>
                    </div>
                    <div className="divider">
                    </div>
                    {
                        getVital().sustained?
                            <div className="row">
                                <span className="label _gray">Watch for</span>
                                <ButtonSwitch label={`${getVital().label}: sustained`} bool={sustainedAlert} onChange={onChangeSustained}/>
                            </div> : ''
                    }
                    {
                        getVital().sustained && sustainedAlert?
                            <VitalAlert alertType={'sustained'} vital={vital} units={getSourceDescription().units} dataFields={sustainedFields} clinicianOptions={clinicianOptions} /> : ''
                    }
                    {
                        getVital().instantaneous?
                            <div className="row">
                                <span className="label _gray">Watch for</span>
                                <ButtonSwitch label={`${getVital().label}: instantaneous`} bool={instantaneousAlert} onChange={onChangeInstantaneous}/>
                            </div> : ''
                    }
                    {
                        getVital().instantaneous && instantaneousAlert?
                            <VitalAlert alertType={'instantaneous'} vital={vital} units={getSourceDescription().units} dataFields={instantaneousFields} clinicianOptions={clinicianOptions} /> : ''
                    }
                </div>
            </div>
        </div>
    )
}

export default VitalCreate;
